import { useTranslation } from '../../lib/i18n'

const ReplyCTA = ({ itemArchived }) => {
  const { t } = useTranslation()
  if (itemArchived) {
    return null
  }

  return (
    <p className="text-disabled text-tiny pb-3 pl-0 md:pl-2">
      {t('activity.noResponsesYet')}
    </p>
  )
}

export default ReplyCTA
